import download from './download';

const path = '/authority'

const authority = (url: string) => () => ({
  download: download(url + path),
});

export default authority;